/* BEGIN MOBILE GALLERY JAVASCRIPT */
/**
 * Mobile Product Card Gallery
 * Handles active dot tracking and scroll alignment for mobile product card image galleries
 */

if (!customElements.get('mobile-card-gallery')) {
  class MobileCardGallery {
    constructor() {
      this.galleries = [];
      this.init();
    }

    init() {
      // Only run on mobile devices
      if (window.innerWidth >= 768) return;

      const galleryElements = document.querySelectorAll('[data-mobile-gallery]');

      galleryElements.forEach((gallery) => {
        const track = gallery.querySelector('.card__mobile-gallery-track');
        const dots = gallery.querySelectorAll('.card__mobile-gallery-dot');

        if (!track || dots.length === 0) return;

        const galleryInstance = {
          gallery,
          track,
          dots,
          currentIndex: 0,
          scrollTimeout: null
        };

        this.galleries.push(galleryInstance);
        this.attachScrollListener(galleryInstance);
      });
    }

    attachScrollListener(instance) {
      const { track, dots } = instance;

      // Update active dot based on scroll position
      const updateActiveDot = () => {
        const scrollLeft = track.scrollLeft;
        const itemWidth = track.offsetWidth;
        const newIndex = Math.round(scrollLeft / itemWidth);

        if (newIndex !== instance.currentIndex && newIndex < dots.length) {
          dots[instance.currentIndex]?.classList.remove('active');
          dots[newIndex]?.classList.add('active');
          instance.currentIndex = newIndex;
        }
      };

      // Align scroll to nearest item when user stops scrolling
      const alignScroll = () => {
        const itemWidth = track.offsetWidth;
        const scrollLeft = track.scrollLeft;
        const targetIndex = Math.round(scrollLeft / itemWidth);
        const targetScroll = targetIndex * itemWidth;

        // Only align if significantly off-center (prevents fighting user swipes)
        if (Math.abs(scrollLeft - targetScroll) > 10) {
          track.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
          });
        }
      };

      // Scroll event handler with debouncing
      track.addEventListener('scroll', () => {
        updateActiveDot();

        // Clear existing timeout
        if (instance.scrollTimeout) {
          clearTimeout(instance.scrollTimeout);
        }

        // Set new timeout for scroll alignment
        instance.scrollTimeout = setTimeout(() => {
          alignScroll();
        }, 150);
      }, { passive: true });
    }

    // Reinitialize on resize (e.g., orientation change)
    handleResize() {
      if (window.innerWidth >= 768) {
        // Desktop: no action needed
        return;
      }

      // Recalculate positions for all galleries
      this.galleries.forEach((instance) => {
        const { track, dots } = instance;
        const itemWidth = track.offsetWidth;
        const targetScroll = instance.currentIndex * itemWidth;

        track.scrollTo({
          left: targetScroll,
          behavior: 'auto'
        });
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      const mobileGallery = new MobileCardGallery();

      // Handle resize/orientation change
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          mobileGallery.handleResize();
        }, 250);
      }, { passive: true });
    });
  } else {
    const mobileGallery = new MobileCardGallery();

    // Handle resize/orientation change
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        mobileGallery.handleResize();
      }, 250);
    }, { passive: true });
  }
}
/* END MOBILE GALLERY JAVASCRIPT */
